import { useEffect, useState } from "react";
import { Row, Card, Button, message, Form, Checkbox } from "antd";
import { Input, Select, Space } from "antd";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { useHistory, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const possibleClients = [
  {
    label: "Mega Image",
    value: "Mega Image",
  },
  {
    label: "LSDV",
    value: "LSDV",
  },
  {
    label: "Sly Nutritia",
    value: "Sly Nutritia",
  },
  {
    label: "RER Ecologic",
    value: "RER Ecologic",
  },
  {
    label: "Grupul Tei",
    value: "Grupul Tei",
  },
  {
    label: "Orshar Logistics",
    value: "Orshar Logistics",
  },
  {
    label: "Aquila",
    value: "Aquila",
  },
  {
    label: "Quehenberger Logistics",
    value: "Quehenberger Logistics",
  },
  {
    label: "NEPI",
    value: "NEPI",
  },
  {
    label: "Professional Farmaline",
    value: "Professional Farmaline",
  },
  {
    label: "Pepco",
    value: "Pepco",
  },
  {
    label: "Electromagnetica",
    value: "Electromagnetica",
  },
  {
    label: "Other",
    value: "Other",
  },
];

const possibleActvityTypes = [
  {
    label: "Verificare agenti la schimbul de tura (L-V)",
  },
  {
    label: "Verificare agenti anterior armare (L-V)",
  },
  {
    label: "Verificare agenti la plecare (S-D)",
  },
  {
    label: "Verificare angajati MI la schimb de tura(L-V)",
  },
  {
    label: "Verificare angajati MI anterior armare (L-V)",
  },
  {
    label: "Verificare angajati MI la plecare (S-D)",
  },
  {
    label: "Verificari de noapte agenti /angajati MI",
  },
  {
    label: "Verificari de zi (L-V) cusete/vestiare/sala mese /zona vanzare",
  },
  {
    label: "Verificari de zi (S-D) cusete/vestiare/sala mese /zona vanzare",
  },
  {
    label: "Control Politie cu SO direct implicat",
  },
  {
    label: "Participare la oprire pers. suspecte de furt.",
  },
  {
    label: "Participare verificari/analizari prejudicii",
  },
  {
    label: "Raportare eveniment",
  },
  {
    label: "Patrulare/stationare echipaje mobile",
  },
  {
    label: "Solicitare telefonica sef magazin",
  },
  {
    label: "Solicitare telefonica agent securitate",
  },
  {
    label: "Solicitare telefonica CMV",
  },
  {
    label: "Preventie/activitate specifica in afara magazinului",
  },
  {
    label: "Servicii de test",
  },
  {
    label: "Control de zi",
  },
  {
    label: "Control de noapte",
  },
  {
    label: "Armare locatie",
  },
  {
    label: "Dezarmare locatie",
  },
  {
    label: "Verificare buton panica",
  },
  {
    label: "Verificare CCTV",
  },
  {
    label: "Verificare porti senzomatice",
  },
  {
    label: "Instruire personal",
  },
  {
    label: "Mentenanta semestiala",
  },
  {
    label: "Verificare coordonator",
  },
  {
    label: "Patrula",
  },
  {
    label: "Verificari angajati la schimb de tura",
  },
  {
    label: "Verificari angajati la inchidere/plecare",
  },
  {
    label: "Confirmare locatie",
  },
  {
    label: "Asistare la receptie marfa",
  },
];

function AddLocation() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [messageApi, contextHolder] = message.useMessage();

  const [region, setRegion] = useState();
  const [client, setClient] = useState();
  const [locationName, setLocationName] = useState();
  const [locationCoordinates, setLocationCoordinates] = useState();
  const [locationAddress, setLocationAddress] = useState();
  const [costCenter, setCostCenter] = useState();
  const [email, setEmail] = useState();
  // const [email2, setEmail2] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [loadingClients, setLoadingClients] = useState(false);
  const [clients, setClients] = useState([]);

  const handleCheckboxChange = (checkedValues) => {
    setSelectedItems(checkedValues);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Location added successfully",
    });
  };
  const error = () => {
    messageApi.open({
      type: "error",
      content: "Location was not added. Please try again later.",
    });
  };

  function checkIfEmail(str) {
    // Regular expression to check if string is email
    const regexExp =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

    return regexExp.test(str);
  }

  const addLocation = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");

    if (
      region &&
      client &&
      locationName &&
      locationCoordinates &&
      locationAddress &&
      costCenter &&
      email
      // email2 &&
      // checkIfEmail(email)
    ) {
      try {
        console.log("TRUE");
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "location/addLocation",
          {
            id: uuidv4(),
            region: region,
            client: client,
            locationName: locationName,
            locationCoordinates: locationCoordinates,
            locationAddress: locationAddress,
            costCenter: costCenter,
            email: email,
            // email2: email2,
            activityType: selectedItems,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response);
        success();
      } catch (e) {
        console.log(e);
        error();
      }
    } else {
      console.log("FALSE");
    }
  };

  const handleChange2 = (item) => {
    setClient(item);
  };

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const getClients = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingClients(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "clients/getAllClients",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setClients(response.data);
      setLoadingClients(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getClients();
  }, []);

  return (
    <>
      {contextHolder}
      <Card
        bordered={false}
        className="header-solid mb-24"
        title={
          <>
            <h6 className="font-semibold">Add Location</h6>
            <p>Add location information below</p>
          </>
        }
      >
        <Row
          style={{
            marginLeft: "20px",
            marginRight: "20px",
          }}
        >
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            onFinish={onFinish}
            initialValues={{
              residence: ["zhejiang", "hangzhou", "xihu"],
              prefix: "004",
            }}
            style={{
              width: "80%",
            }}
            scrollToFirstError
          >
            <Form.Item
              name="region"
              label="Region"
              tooltip="Please provide a region name"
              rules={[
                {
                  required: true,
                  message: "Please input the region!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={region}
                onChange={(e) => setRegion(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              name="client"
              label="Client"
              tooltip="Please specify the client"
              rules={[
                {
                  required: client ? null : true,
                  message: "Please input the client!",
                  whitespace: true,
                },
              ]}
            >
              <Space
                style={{
                  width: "100%",
                }}
                direction="vertical"
              >
                <Select
                  mode="single"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Please select"
                  // defaultValue={[]}
                  onChange={handleChange2}
                  options={clients.map((client) => {
                    return {
                      label: client?.name,
                      value: client?.name,
                    };
                  })}
                />
              </Space>
            </Form.Item>

            <Form.Item
              name="locationName"
              label="Location Name"
              tooltip="Please provide a location name"
              rules={[
                {
                  required: true,
                  message: "Please input the location name!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={locationName}
                onChange={(e) => setLocationName(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              name="locationCoordinates"
              label="Location Coordinates"
              tooltip="Must be in the following format: 45.45118874636798, 28.04225951205401"
              rules={[
                {
                  required: true,
                  message: "Please input the location coordinates!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={locationCoordinates}
                onChange={(e) => setLocationCoordinates(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              name="locationAddress"
              label="Location Address"
              rules={[
                {
                  required: true,
                  message: "Please input the location address!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={locationAddress}
                onChange={(e) => setLocationAddress(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              name="costCenter"
              label="Cost Center"
              rules={[
                {
                  required: true,
                  message: "Please input the location cost center!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={costCenter}
                onChange={(e) => setCostCenter(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              name="emails"
              label="Emails"
              tooltip="Please input the client's valid email addresses separated by semicolumns `;` (Eg: 'premium-cms@gmail.com; tehnic@premium-cms.ro')"
              rules={[
                {
                  required: true,
                  message:
                    "Please input the client's valid email addresses separated by semicolumns `;` (Eg: 'premium-cms@gmail.com; tehnic@premium-cms.ro')!",
                  whitespace: true,
                  // type: "email",
                },
              ]}
            >
              <Input value={email} onChange={(e) => setEmail(e.target.value)} />
            </Form.Item>

            {/*<Form.Item*/}
            {/*  name="email2"*/}
            {/*  label="Email 2"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: true,*/}
            {/*      message: "Please input the client valid email address!",*/}
            {/*      whitespace: true,*/}
            {/*      type: "email",*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Input*/}
            {/*    value={email2}*/}
            {/*    onChange={(e) => setEmail2(e.target.value)}*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            <Form.Item label="Activity Types">
              <Checkbox.Group
                onChange={handleCheckboxChange}
                value={selectedItems}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                {possibleActvityTypes.map((item) => (
                  <Checkbox
                    style={{ marginLeft: "6px" }}
                    key={item.label}
                    value={item.label}
                  >
                    {item.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </Form.Item>

            <Form.Item {...tailFormItemLayout}>
              <Button
                type="secondary"
                className="tag-primary"
                htmlType="submit"
                onClick={() => addLocation()}
              >
                Create Location
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Card>
    </>
  );
}

export default AddLocation;
